(function () {
  'use strict';

  angular
    .module('doubleSectorCount')
    .service('doubleSectorCountService', doubleSectorCountService);

  function doubleSectorCountService(CommonMasterData,RemoteService) {
    var vm = this;

    vm.searchDoubleSectorCount = function (param ,successFn,errorFn) {
      var searchParam = adaptSearchRequset(param);
      RemoteService.searchDoubleSectorCount(searchParam).then(
        function (response) {
          successFn(response);
        },
        function (error) {
          errorFn(error.msg);
        }
      );
    };

    function adaptSearchRequset(param) {
      var actualSearchParam = {
        fromDate : param.fromDate,
        toDate: param.toDate,
        crewType:(param.crewType !=null ) ? param.crewType.crewTypeCode:null,
        crewBase:(param.crewBase !=null ) ? param.crewBase.airPortCode:null,
        autoOrManual: (param.autoOrManual != null) ? param.autoOrManual.autoOrManualCode:null
      };

      return actualSearchParam;
    }

  }
}());
